import {mapMutations} from "vuex";

const mixin = {
    data() {
        return {
            screenWidth: 0,
        }
    },
    methods: {
        ...mapMutations({
            blockPerPage: 'streams/setBlocksPerPage'
        }),
        handleResize() {
            this.screenWidth = window.innerWidth;
        },
        setCardIcon(element) {
            let icon = '';

            if(element.icon){
                return element.icon;
            }

            switch (element.type.toLowerCase()) {
                case 'mission': {
                    icon = '/images/master-dashboard/star_unlocked.svg'
                    break;
                }
                case 'webinar': {
                    icon = '/images/streams/icon_webinar.svg'
                    break;
                }
                default: {
                    icon = '/images/master-dashboard/check_unlocked.svg'
                }
            }
            return icon;
        },
        cardElementType(miuType, elementType){
            return miuType ? this.trans('streams.dashboard.' + `${miuType.name}`) : this.trans(this.elementTypeTitle(elementType))
        },
        ifTypeOpenOrWebinar(status, type) {
            if(status !== 'open' || type === 'Webinar') return;
        },
        elementTypeTitle(type){
            switch (type){
                case 'Miu':
                    return 'streams.dashboard.miu_title';
                case 'Mission':
                    return 'streams.dashboard.mission_title';
                case 'Webinar':
                    return 'streams.dashboard.webinar_title';
            }
        },
        aleTypeTitle(type){
            switch (type){
                case 'introduction':
                    return 'streams.dashboard.introduction';
                case 'conclusion':
                    return 'streams.dashboard.conclusion';
                case 'learning_peak':
                    return 'streams.dashboard.learning_peak';
                case 'mission':
                    return 'streams.dashboard.mission';
                case 'microlearning':
                    return 'streams.dashboard.microlearning';
            }
        },
        itemRoute(streamId, aleId, localisation, element, status) {
            let routeName = '';
            switch (element.type){
                case 'Miu':
                    routeName = 'stream-miu';
                    break;
                case 'Mission':
                    routeName = `stream-mission`;
                    break;
            }

            const params = {
                id: streamId,
                localisation: localisation,
                aleId: aleId,
                elementId: element.id,
                status: status ? status : 'instructions'
            };

            return {name: routeName, params: params};
        },
        async completeActivity(elementId, elementType, streamId, elementSoftSkills) {
            const activityData = [];
            let completedActivity = {
                main: {
                    action: "completed",
                    objectId: elementId,
                    objectType: elementType,
                },
                details: [
                    {
                        key: "stream_id",
                        value: streamId
                    }
                ]
            }
            activityData.push(completedActivity);

            if(elementSoftSkills){
                const softSkillsActivity = elementSoftSkills.map(skill => (
                    {
                        main: {
                            action: "completed",
                            objectId: skill.id,
                            objectType: "softskill",
                        },
                        details: [
                            {
                                key: `${elementType}_id`,
                                value: elementId.toString()
                            }
                        ]
                    })
                )
                activityData.concat(softSkillsActivity);
            }
            await this.submitActivity({data: activityData}); 
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
};

export default mixin;
